<div class="error-message" *ngIf="showEtiquetaError || showNoImageError || showIdentificadorError">Por favor, rellena los campos obligatorios.</div>
<div class="error-message" *ngIf="telefonoError || errorEmail || showImageErrorMessage">Hay campos con un formato incorrecto.</div>
<div class="ok-message fade-out" *ngIf="!showEtiquetaError && !showNoImageError && !showIdentificadorError && establecimientoEditado">
    El establecimiento se ha editado correctamente.
</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorFinalMessage}}</div>

<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">EDITAR ESTABLECIMIENTO</span>
            <button mat-icon-button matTooltip="Guardar cambios" class="gurdar-btn" (click)="guardarDispositivo()" [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text font14">Formulario de actualización de establecimientos DataBeer</span>
    </div>
    <div class="body">

        <!--DISPOSITIVO-->

        <div class="datos-dispositivo">

            <div class="datos-dispositivo-header">
                <span>DATOS DEL ESTABLECIMIENTO</span>
            </div>

            <div class="margin20">
                <span class="custom-label">Identificador Único: </span>
                <mat-form-field class="form-field-custom">
                    <mat-label [ngClass]="{'error-select': showIdentificadorError}">Identificador del Establecimiento</mat-label>
                    <input matInput type="text" [(ngModel)]="identificador" placeholder="Identificador único del usuario" 
                    value="{{this.establecimientoActual.dev_label}}" required>
                    <button *ngIf="identificador" matSuffix mat-icon-button aria-label="Clear" (click)="identificador=''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-error *ngIf="showIdentificadorError" class="custom-error">Introduzca un identificador</mat-error>
            </div>

            <div>
                <span class="custom-label">Nombre: </span>
                <mat-form-field class="form-field-custom">
                    <mat-label [ngClass]="{'error-select': showEtiquetaError}">Nombre del establecimiento</mat-label>
                    <input matInput type="text" [(ngModel)]="etiqueta" placeholder="Nombre de una localidad, parroquia, nucleo, etc..." 
                    value="{{this.establecimientoActual.dev_label}}" (ngModelChange)="updateEstadoErrorEtiqueta()" required>
                    <button *ngIf="etiqueta" matSuffix mat-icon-button aria-label="Clear" (click)="etiqueta=''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-error *ngIf="showEtiquetaError" class="custom-error1">Introduzca una etiqueta</mat-error>    
            </div>

            <div *ngIf="userData.pro_id == 4">
                <span class="custom-label" [ngClass]="{'error-select': showClienteError}">Cliente:</span>
                <mat-form-field class="form-field-custom">
                    <mat-label [ngClass]="{'error-select': showClienteError}">-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedCliente" name="est" (selectionChange)="updateEstadoErrorCliente()" required>
                      <mat-option *ngFor="let est of clientes" [value]="est.value">
                        {{est.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error *ngIf="showClienteError" class="custom-error1">Selecciona un cliente</mat-error>
            </div>

            <div class="estado-container">
                <span class="titulos-dispositivo">Cerveza: </span> <span> Tipos de cerveza</span>
                <mat-form-field class="etiqueta-container margin0" appearance="outline">
                    <input matInput type="text" [value]="obtenerNombresDeCervezas()" [readonly]="true">
                </mat-form-field>
            </div>


            <div class="estado-container">
                <span class="custom-label">Estado: *</span>
                <mat-form-field class="form-field-custom">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedEstado" name="est">
                      <mat-option *ngFor="let est of estado" [value]="est.value">
                        {{est.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!--DATOS DE CONTACTO-->

            <div class="datos-contacto-header">
                <span>DATOS DE CONTACTO</span>
            </div>

            <form [formGroup]="signin">
                <mat-form-field class="etiqueta-container margin20">
                    <mat-label class="label-text">Contacto</mat-label>
                    <input matInput type="text" placeholder="Nombre de contacto" formControlName="contacto">
                    <button *ngIf="contactoInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('contacto')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </form>

            <form [formGroup]="signin">
                <mat-form-field class="input-container2 widht100" >
                    <mat-label class="label-text" [ngClass]="{'error-select': telefonoError}">Teléfono</mat-label>
                    <input matInput placeholder="600 00 00 00" formControlName="telefono" mask="000 00 00 00">
                    <mat-icon matPrefix>phone</mat-icon>
                    <button *ngIf="telefonoInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('telefono')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-error *ngIf="telefonoError" class="custom1">El número de teléfono introducido no es correcto.</mat-error>
            </form>

            <form [formGroup]="signin">
                <mat-form-field class="input-container2 widht100" >
                    <mat-label class="label-text" [ngClass]="{'error-select': errorEmail}">Correo electrónico</mat-label>
                    <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech" formControlName="email">
                    <button *ngIf="emailInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('email')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-error *ngIf="errorEmail" class="custom2">Introducizca un email válido</mat-error>
            </form>

            <div class="custom4">
                <div>
                    <span class="titulos-dispositivo" [ngClass]="{'error-select': showNoImageError || showImageErrorMessage}">Imagen: </span>
                    <span [ngClass]="{'error-select': showNoImageError || showImageErrorMessage}">Imagen del establecimiento (solo JPG).</span>
                </div>
                <div>
                    <button type="button" mat-raised-button (click)="fileInput.click()" class="boton-imagen">Elige una imagen</button>
                    <span *ngIf="file !== undefined" class="marginleft10">{{file.name}}</span>
                </div>
                <input hidden #fileInput type="file" id="image_uploads" (change)="onFileSelected($event)" accept="image/jpeg" class="imagen-custom">
                <mat-error *ngIf="showNoImageError" class="custom5">Seleccione una imagen</mat-error>
                <mat-error *ngIf="showImageErrorMessage" class="marginTop10">Por favor, seleccione un archivo .jpg</mat-error>
                <img *ngIf="imageUrl" [src]="imageUrl" alt="Vista previa de imagen establecimiento" class="imagen-dispositivo">
                <img *ngIf="est_img_path !== '' && !imageUrl" src={{est_img_path}} alt="Vista previa de imagen establecimiento" class="imagen-dispositivo">
                <span *ngIf="est_img_path === '' && !imageUrl" class="custom6">(No encontrada)</span>
                <img *ngIf="est_img_path === '' && !imageUrl" src="assets/images/icons8-not-found-96.png" alt="No encontrado" class="imagen-dispositivo">
            </div>

        </div>

        <div class="datos-instalacion">

            <div class="datos-instalacion-header">
                <span>UBICACIÓN DEL ESTABLECIMIENTO</span>
            </div>

            <div class="buscador-container custom">
                <input class="form-control custom3" type="text" [(ngModel)]="searchPlace" id="pac-input" placeholder="Buscar en el mapa..."/>
            </div>
            <div class="mapa-container">
                <!--<agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [mapTypeControl]="true" mapTypeId="hybrid" (mapClick)="onChoseLocation($event)">
                    <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
                </agm-map>-->
                <div id="map" class="height450"></div>
            </div>

            <div class="referencia-container margin20" >
                <span class="custom-label">Dirección completa: </span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="direccionCompleta">
                    <input matInput type="text" [readonly]="true" value="{{direccionCompleta}}"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="!direccionCompleta">
                    <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                </mat-form-field>
            </div>

            <mat-form-field class="lat-container widht100" >
                <mat-label class="label-text">Latitud</mat-label>
                <input matInput type="number" [(ngModel)]="lat" placeholder="Selecciona la latitud" value="{{lat}}" (ngModelChange)="updateLocation()">
                <button matSuffix mat-icon-button aria-label="Clear" (click)="refresh()">
                    <mat-icon>refresh</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="lng-container widht100" >
                <mat-label class="label-text">Longitud</mat-label>
                <input matInput type="number" [(ngModel)]="lng" placeholder="Selecciona la latitud" value="{{lng}}" (ngModelChange)="updateLocation()">
                <button matSuffix mat-icon-button aria-label="Clear" (click)="refresh()">
                    <mat-icon>refresh</mat-icon>
                </button>
            </mat-form-field>

        </div>

        <!--DISPOSITIVOS-->

        <div class="acceso-usuarios margin20">
            <div class="acceso-usuarios-header">
                <span>DISPOSITIVOS DEL ESTABLECIMIENTO</span>
            </div>

            <div class="top-container custom7">
                <mat-form-field>
                    <mat-label class="negro">Filtrar</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
                </mat-form-field>
            </div>

            <div class="tabla">
                <table mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="dev_reference">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Referencia </th>
                        <td mat-cell *matCellDef="let element" class="login-cell"> {{element.dev_reference}} </td>
                    </ng-container>

                    <ng-container matColumnDef="dev_label">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                        <td mat-cell *matCellDef="let element" class="router-cell" routerLink="/dispositivo/ver/{{element.id}}"> {{element.dev_label}} </td>
                    </ng-container>

                    <ng-container matColumnDef="clientId" *ngIf="userData.pro_id == 4">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente</th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{ element.clientId }} </td>
                    </ng-container>

                    <ng-container matColumnDef="dev_create_at">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha de alta </th>
                        <td mat-cell *matCellDef="let element"> {{element.dev_create_at}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="operaciones">
                        <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                        <td mat-cell *matCellDef="let element">
                          <div class="button-container">
                            <button mat-mini-fab class="ver-btn" matTooltip="Ver dispositivo" aria-label="Ver establecimiento" routerLink="/dispositivo/ver/{{element.id}}">
                              <mat-icon>remove_red_eye</mat-icon>
                            </button>
                            <button mat-mini-fab class="edit-btn" matTooltip="Editar dispositivo" aria-label="Editar establecimiento" routerLink="/{{element.id}}/editar/dispositivo">
                              <mat-icon>edit</mat-icon>
                            </button>
                          </div>
                        </td>
                      </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <mat-paginator #paginator1
                    [pageSizeOptions]="[15,30,60]" 
                    showFirstLastButtons 
                    aria-label="Elige una página"
                    class="paginatorCustom">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>
